<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h3>Bookings</h3>
    </div>
    <ul class="nav nav-tabs " id="tabs" >
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active-tab':selMenu=='bookings'}" (click)="selectMenu('bookings')">Bookings</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active-tab':selMenu=='telegram-bookings'}" (click)="selectMenu('telegram-bookings')">
          Telegram Orders 
        </a>
      </li>
    </ul>
    <div class="row"  [ngStyle]="{'display': selMenu=='bookings' ? 'block' :'none' }" class="mt-3">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Customer Name</th>
                <th scope="col">Product Name</th>
                <th scope="col">BookedTime</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let booking of bookings; let i = index">
                <th scope="row">{{ i + 1 }}</th>
                <td>
                  {{ booking.user_detail.first_name }}
                  {{ booking.user_detail.last_name }}
                </td>
                <td>{{ booking.food.name }}</td>
                <td>{{ booking.bookingTime | date : "dd-MM-yyyy HH:mm" }}</td>
                <!-- <td>
                                    <div class="status_group">
                                        <select class="form-control"
                                            (change)="change_order_status(order.id, $event.target.value)"
                                            [(ngModel)]="order.status">
                                            <option value="" disabled>Status</option>
                                            <option value="0">Pending</option>
                                            <option value="1">Accept</option>
                                            <option value="2">Cancel</option>
                                            <option value="3">Refund</option>
                                        </select>
                                        <i class="fa-solid fa-circle fa-2x pending_status"
                                            *ngIf="order.status == 0"></i>
                                        <i class="fa-solid fa-circle fa-2x accept_status"
                                            *ngIf="order.status == 1"></i>
                                        <i class="fa-solid fa-circle fa-2x cancel_status"
                                            *ngIf="order.status == 2"></i>
                                        <i class="fa-solid fa-circle fa-2x refund_status"
                                            *ngIf="order.status == 3"></i>
                                    </div>
                                </td> -->
                <!-- <td>
                                    <i class="fa-solid fa-eye"
                                        (click)="order_details(order_details_popup, order.id)"></i>&nbsp;
                                    <i class="fa-solid fa-square"></i>
                                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row"  [ngStyle]="{'display': selMenu=='telegram-bookings' ? 'block' :'none' }" class="mt-3">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Customer Name</th>
                <th scope="col">Product Name</th>
                <th scope="col">Taken?</th>
                <th scope="col">Booked Time</th>
                
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let telegramBooking of telegramBookings; let i = index">
                <th scope="row">{{ i + 1 }}</th>
                <td>
                  <!-- {{ telegramBooking.user_detail.first_name }}
                  {{ telegramBooking.user_detail.last_name }} -->
                   {{telegramBooking['userName']}}
                </td>
                <td> {{telegramBooking['itemName']}}</td>
                <td  [ngClass]="telegramBooking['is_taken']? 'taken taken_yes' : 'taken taken_no' " >{{telegramBooking['is_taken'] ? "YES" : "NO"}}</td>
                <td>{{telegramBooking.time}}</td>
                
              </tr>
            </tbody>
          </table>
          <div id="pagination-controlls">
            <div id="pagination-page-selector">
              <button (click) ="decreasePageIndex()" class="btn btn-primary"> &lt;</button>
               <span>{{telegramTablePage}}</span> 
              <button (click) ="increasePageIndex()"  class="btn btn-primary"> &gt;</button>
            </div>
            <span id="pagination-date-picker">Load Since: <input
              [ngModel] = "telegramFetchSinceDate"
              (ngModelChange)="telegramFetchSinceDate = $event; getTelegramBookings(); telegramTablePage=1;"
              type="date" /></span>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #order_details_popup let-modal>
  <div class="modal-content">
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <i
              class="fa-regular fa-circle-xmark fa-2x"
              (click)="modalService.dismissAll()"
            ></i>
          </div>
          <div class="">
            <h2 class="cart_title">Order Detail</h2>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center">
          <div class="order_item_pop">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Image</th>
                  <th scope="col">Product</th>
                  <th scope="col">Variation</th>
                  <th scope="col">Price</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Item Total</th>
                  <th scope="col">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    for;
                    let item;
                    of: order_detail.cartOrderItems;
                    let i = index
                  "
                >
                  <th scope="row">{{ i + 1 }}</th>
                  <td>
                    <img loading="lazy"
                      src="{{ imgUrl }}{{ item.foodImage }}"
                      class="item_img"
                    />
                  </td>
                  <td>{{ item.food.name }}</td>
                  <td>{{ item.foodSpecLeft }}</td>
                  <td>${{ item.foodSpecRight }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.foodSpecRight * item.quantity }}</td>
                  <td>{{ item.remarks }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <h2 class="cart_title">BILLING INFORMATION</h2>
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Detail</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Name</th>
                <td>{{ order_detail.cartTransaction.name }}</td>
              </tr>
              <tr>
                <th scope="row">Phone Number</th>
                <td>{{ order_detail.cartTransaction.unit }}</td>
              </tr>
              <tr>
                <th scope="row">Address</th>
                <td>{{ order_detail.cartTransaction.address }}</td>
              </tr>
              <tr>
                <th scope="row">Postal Code</th>
                <td>{{ order_detail.cartTransaction.postalCode }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-6">
          <h2 class="cart_title">SCREENSHOT</h2>
          <img loading="lazy" src="{{ imgUrl }}{{ order_detail.screenshot }}" />
        </div>
      </div>
    </div>
  </div>
</ng-template>
